import { AssociationType } from '@libs/associations';
import type { LabeledAttribute } from '@libs/attribute.helper';
import type { AssociationProductFragmentEnhanced, ProductFragmentEnhanced } from '@models/enhanced-fragments';
import type { SupportTrayProduct } from '@product/VariantSelector/SupportTraySelector/SupportTraySelector';

/**
 * Returns only relevant support tray products.
 */
export const getFilteredSupportTrayProducts = (
  product: ProductFragmentEnhanced,
  associatedProducts: Record<string, AssociationProductFragmentEnhanced>
): SupportTrayProduct[] => {
  // support tray products must have one of these association types
  const supportTrayAssociationTypes = [AssociationType.SUPPORT_TRAY];

  const supportTrayProducts: SupportTrayProduct[] = [];
  product.product_to_product_associations
    ?.filter(association =>
      supportTrayAssociationTypes.some(supportTrayAssociationType => association.type === supportTrayAssociationType)
    )
    .map(association => associatedProducts[association.productByProductIdTarget?.id || ''])
    .filter(associatedProduct => associatedProduct)
    ?.forEach(associatedProduct => {
      const assocProductKey = (associatedProduct.attributes?.type_support_tray as LabeledAttribute<string>)?.value_key;

      let entry = supportTrayProducts.find(value => value.key === assocProductKey);

      if (!entry && assocProductKey) {
        entry = {
          key: assocProductKey,
          products: [],
        };
        supportTrayProducts.push(entry);
      }

      if (entry) {
        entry.products.push(associatedProduct);
      }
    });
  if (supportTrayProducts.length === 0) {
    return [];
  }
  return supportTrayProducts;
};
